import React from 'react';
import HeroSection from '../components/Sections/HeroSection';
import SectionHeader from '../components/Sections/SectionHeader';
import { 
  FaBullseye, 
  FaEye, 
  FaHandshake, 
  FaLightbulb, 
  FaChartLine,
  FaUsers as FaUsersIcon
} from 'react-icons/fa';

const About = () => {
  const coreValues = [
    {
      icon: FaHandshake,
      title: 'Integrity',
      description: 'We maintain transparency and ethical standards in all our dealings.'
    },
    {
      icon: FaLightbulb,
      title: 'Innovation',
      description: 'Constantly evolving with technology to deliver cutting-edge solutions.'
    },
    {
      icon: FaUsersIcon,
      title: 'Inclusivity',
      description: 'Solutions designed for every scale, budget, and background.'
    },
    {
      icon: FaChartLine,
      title: 'Impact',
      description: 'Focus on delivering measurable results and tangible growth.'
    }
  ];

  return (
    <div>
      <HeroSection
        title="People-Powered Innovation"
        subtitle="We are a collective of thinkers, developers, marketers, and trainers dedicated to driving growth."
        showButtons={false}
      />

      {/* Our Story */}
      <section className="py-5">
        <div className="container">
          <SectionHeader 
            title="Our Journey"
            subtitle="From vision to impact"
          />
          
          <div className="row align-items-center">
            <div className="col-lg-6">
              <p className="lead mb-4">
                Founded on the principle of empowering businesses and individuals through technology, 
                <strong> MPEOPLES BUSINESS SOLUTION PVT LTD</strong> has grown from a startup vision to a 
                multi-service solution provider.
              </p>
              <p className="mb-4">
                Our journey began with a simple idea: to create digital solutions that are accessible, 
                affordable, and effective. Today, we impact SMEs, students, and brands across India 
                with our comprehensive suite of services.
              </p>
              <p className="mb-0">
                What sets us apart is our <strong>"Powered by the People, for the People"</strong> philosophy. 
                We believe that the best solutions come from understanding real people's needs and 
                leveraging technology to solve them.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-lg">
                <div className="card-body p-5">
                  <h4 className="fw-bold mb-4">Our Growth Timeline</h4>
                  
                  <div className="timeline">
                    <div className="timeline-item mb-4">
                      <div className="timeline-marker bg-primary"></div>
                      <div className="timeline-content">
                        <h6 className="fw-bold">2018 - Foundation</h6>
                        <p className="text-muted mb-0">Started with web development services</p>
                      </div>
                    </div>
                    
                    <div className="timeline-item mb-4">
                      <div className="timeline-marker bg-success"></div>
                      <div className="timeline-content">
                        <h6 className="fw-bold">2019 - Expansion</h6>
                        <p className="text-muted mb-0">Added digital marketing and training services</p>
                      </div>
                    </div>
                    
                    <div className="timeline-item mb-4">
                      <div className="timeline-marker bg-info"></div>
                      <div className="timeline-content">
                        <h6 className="fw-bold">2020 - Platform Launch</h6>
                        <p className="text-muted mb-0">Introduced our own platforms and products</p>
                      </div>
                    </div>
                    
                    <div className="timeline-item">
                      <div className="timeline-marker bg-warning"></div>
                      <div className="timeline-content">
                        <h6 className="fw-bold">2021-Present - Multi-Service Hub</h6>
                        <p className="text-muted mb-0">Became a complete business solution provider</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="text-center p-4 h-100 d-flex flex-column justify-content-center">
                <FaBullseye className="display-4 text-primary mb-4" />
                <h3 className="fw-bold mb-3">Our Mission</h3>
                <p className="lead">
                  To deliver accessible, high-quality digital and technology services that solve 
                  real-world problems for businesses and learners.
                </p>
              </div>
            </div>
            
            <div className="col-lg-6">
              <div className="text-center p-4 h-100 d-flex flex-column justify-content-center">
                <FaEye className="display-4 text-primary mb-4" />
                <h3 className="fw-bold mb-3">Our Vision</h3>
                <p className="lead">
                  To be the most trusted partner for integrated business solutions, known for our 
                  people-centric approach and innovative platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-5">
        <div className="container">
          <SectionHeader 
            title="Our Core Values"
            subtitle="The principles that guide everything we do"
          />
          
          <div className="row g-4">
            {coreValues.map((value, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body text-center p-4">
                    <value.icon className="display-4 text-primary mb-3" />
                    <h5 className="fw-bold mb-3">{value.title}</h5>
                    <p className="text-muted mb-0">{value.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;